import React, { useState } from "react";
import { DateTime } from "luxon";

import { presetGroups, DatePreset } from "./datePresets";

type DateRangeQuickSelectProps = {
  selectedStart: Date | null | undefined;
  selectedEnd: Date | null | undefined;
  onSelect(range: [Date, Date]): void;
};

function isSameDay(a: Date, b: Date | null | undefined): boolean {
  if (!b) return false;
  return DateTime.fromJSDate(a).toISODate() === DateTime.fromJSDate(b).toISODate();
}

const DateRangeQuickSelect: React.FC<DateRangeQuickSelectProps> = ({
  selectedStart,
  selectedEnd,
  onSelect,
}) => {
  const [openGroup, setOpenGroup] = useState<string | null>(null);

  const handlePresetClick = (preset: DatePreset) => {
    onSelect(preset.getRange());
  };

  const isPresetActive = (preset: DatePreset): boolean => {
    const [start, end] = preset.getRange();
    return isSameDay(start, selectedStart) && isSameDay(end, selectedEnd);
  };

  return (
    <div className="date-quick-select">
      {presetGroups.map((group) => {
        const isSingle = group.presets.length === 1;
        const isOpen = openGroup === group.key;
        const isGroupActive = group.presets.some(isPresetActive);

        if (isSingle) {
          return (
            <button
              key={group.key}
              type="button"
              className={`date-quick-select__item${
                isGroupActive ? " date-quick-select__item--active" : ""
              }`}
              onClick={() => handlePresetClick(group.presets[0])}
            >
              {group.label}
            </button>
          );
        }

        return (
          <div
            key={group.key}
            className="date-quick-select__group"
            onMouseEnter={() => setOpenGroup(group.key)}
            onMouseLeave={() =>
              setOpenGroup((prev) => (prev === group.key ? null : prev))
            }
          >
            <button
              type="button"
              className={`date-quick-select__item date-quick-select__item--parent${
                isGroupActive ? " date-quick-select__item--active" : ""
              }`}
              onClick={() =>
                setOpenGroup((prev) => (prev === group.key ? null : group.key))
              }
            >
              <span>{group.label}</span>
              <i className="fas fa-chevron-right fa-xs"></i>
            </button>
            {isOpen && (
              <div className="date-quick-select__submenu">
                {group.presets.map((preset) => (
                  <button
                    key={preset.key}
                    type="button"
                    className={`date-quick-select__item${
                      isPresetActive(preset)
                        ? " date-quick-select__item--active"
                        : ""
                    }`}
                    onClick={() => handlePresetClick(preset)}
                  >
                    {preset.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DateRangeQuickSelect;
